export const EnableGrantButton = {
  mounted() {
    this.numCreditsEl = this.el.querySelector(
      'input[type="text"][id*="num_credits"]',
    )
    this.creditTypeEl = this.el.querySelector('select[id*="credit_type"]')
    this.grantButtonEl = this.el.querySelector('button[id*="grant-button"]')
    this.buttonToggleListener = () => {
      const numCredits = parseInt(this.numCreditsEl.value)
      const creditTypeSelected = this.creditTypeEl.value !== ""
      this.grantButtonEl.disabled = !(numCredits > 0 && creditTypeSelected)
    }

    this.numCreditsEl.addEventListener("input", this.buttonToggleListener)
    this.creditTypeEl.addEventListener("input", this.buttonToggleListener)

    this.buttonToggleListener()
  },
  destroyed() {
    this.numCreditsEl.removeEventListener("input", this.buttonToggleListener)
    this.creditTypeEl.removeEventListener("input", this.buttonToggleListener)
    this.grantButtonEl.disabled = true
  },
}
